import * as echarts from 'echarts'
import DataService from '@/api/data';
import store from '@/store'
function chinaMap(){
    var chinaGeoCoordMap = {
        '上海': [121.473667,31.230525],
    };
    var chinaDatas = [];
    DataService.getMapInfo({
        user_id:store.state.user_id
    }).then(res=>{
        res.data.forEach(el=>{
            chinaGeoCoordMap[el.geteway_name] = [Number(el.longitude),Number(el.latitude)]
            chinaDatas.push([{
                name:el.geteway_name,
                value:0,
                templateName:el.templateName,
                serial_number:el.serial_number
            }])
        })
        charts()
    }).catch(err=>{
    })
    function charts(){
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('map_1'));
    var convertData = function(data) {
        var res = [];
        for(var i = 0; i < data.length; i++) {
            var dataItem = data[i];
            var fromCoord = chinaGeoCoordMap[dataItem[0].name];
            var toCoord = [121.473667,31.230525];//中心点地理坐标
            if(fromCoord && toCoord) {
                res.push([{
                    coord: fromCoord,
                    value: dataItem[0].value
                }, {
                    coord: toCoord,
                }]);
            }
        }
        console.log(res)
        return res;
    };
    var series = [];
    [['上海', chinaDatas]].forEach(function(item, i) {
        series.push({
                type: 'lines',
                zlevel: 1,
                animation:false,
                effect: {
                    show: true,
                    period: 4, //箭头指向速度，值越小速度越快
                    trailLength: 0.02, //特效尾迹长度[0,1]值越大，尾迹越长重
                    symbol: 'arrow', //箭头图标
                    symbolSize: 5, //图标大小
                    color:'#53B5EA'
                },
                lineStyle: {
                    normal: {
                        width: 1, //尾迹线条宽度
                        opacity: 1, //尾迹线条透明度
                        curveness: .2,//尾迹线条曲直度
                        color:'#53B5EA'
                    }
                },
                data: convertData(item[1])
            }, 
            {
                type: 'effectScatter',
                coordinateSystem: 'geo',
                animation:false,
                zlevel: 2,
                rippleEffect: { //涟漪特效
                    // period: 4, //动画时间，值越小速度越快
                    brushType: 'stroke', //波纹绘制方式 stroke, fill
                    // scale: 4 //波纹圆环最大限制，值越大波纹越大
                },
                label: {
                    normal: {
                        show: true,
                        position: 'right', //显示位置
                        offset: [5, 0], //偏移设置
                        formatter: function(params){//圆环显示文字
                            console.log(params)
                            return params.data.name;
                        },
                        fontSize: 13
                    },
                    emphasis: {
                        show: true
                    }
                },
                symbol: 'circle',
                // symbolSize: function(val) {
                //     return 5+ val[2]; //圆环大小
                // },
                itemStyle: {
                    normal: {
                        show: false,
                        color: '#53B5EA'//坐标点的颜色
                    }
                },
                data: item[1].map(function(dataItem) {
                    return {
                       //在这里定义你所要展示的数据
                        name: dataItem[0].name,
                        value: chinaGeoCoordMap[dataItem[0].name].concat([dataItem[0].value]),
                    };
                }),
            },
            //中心点
            // {
            //     type: 'scatter',
            //     coordinateSystem: 'geo',
            //     zlevel: 2,
            //     // rippleEffect: {
            //     //     period: 4,
            //     //     brushType: 'stroke',
            //     //     scale: 4
            //     // },
            //     label: {
            //         normal: {
            //             show: false,
            //             position: 'right',
            //             //offset:[5, 0],
            //             color: '#53B5EA',
            //             formatter: '{b}',
            //             textStyle: {
            //                 color: "#53B5EA"//中心点颜色
            //             }
            //         },
            //         emphasis: {
            //             show: true,
            //             color: "#fff"
            //         }
            //     },
            //     symbol: 'pin',
            //     symbolSize: 30,
            //     data: [{
            //         name: item[0],
            //         value: chinaGeoCoordMap[item[0]].concat([10]),
            //     }],
            // }
        );
    });

    var option = {
        tooltip: {
            trigger: 'item',
            triggerOn:'click',
            backgroundColor: 'rgba(1,9,54,0.8)',
            borderColor: '#FFF',
            showDelay: 0,
            hideDelay: 0,
            enterable: true,
            transitionDuration: 0,
            extraCssText: 'z-index:100',
            formatter: function(params, ticket, callback) {
                console.log(params)
                //根据业务自己拓展要显示的内容
                var res = "";
                var name = params.name;
                if(params.value){
                    var value = params.value[params.seriesIndex + 1];
                    res = "<span style='color:#fff;'>" + name + "</span><br/>数据：" + value;
                }
                return res;
            }
        },
        geo: {
            map: 'china',
            zoom: 1.2,
            label: {
                emphasis: {
                    show: false
                }
            },
            roam: false, //是否允许缩放
            itemStyle: {
                normal: {
                    color: 'rgba(0,192,255,0.6)', //地图背景色
                    borderColor: '#00DEFF', //省市边界线00fcff 516a89
                    borderWidth: 1
                },
                emphasis: {
                    color: 'rgba(37, 43, 61, .5)' //悬浮背景
                }
            }
        },
        series: series
    };
    
    myChart.setOption(option,true);
    window.addEventListener("resize",function(){
        var chart = document.getElementById('map_1');
        if(chart != null){
            myChart.resize();
        }else{
            echarts.dispose(myChart)
        }
    });
    // myChart.on('click', function(params){
    //     alert(params.name);
    //     console.log(params);//此处写点击事件内容
    // });
    }
}
export default chinaMap;